<template>
	<div class="container">
		<div class="main_box">
			<div v-if="false" class="lang_box" @click="checkLang">{{ $t('language.language') }}</div>
			<div class="bg_box">
				<img src="../../assets/img/login/bg.webp" />
			</div>
			<div class="msg_box">
				<div class="left">
					<img src="../../assets/img/login/block_1.webp" />
				</div>
				<div class="right">
					<div class="top_box">
						<img src="../../assets/img/login/block_2.webp" />
						<div class="tit">{{ $t('LOGIN.txt1') }}</div>
					</div>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
						<div class="input_el">
							<div class="tit">{{ isCode ? $t('LOGIN.txt17') : $t('LOGIN.txt2') }}</div>
							<el-form-item label="" prop="account">
								<el-input v-model="ruleForm.account" :placeholder="isCode ? $t('LOGIN.txt18') : $t('LOGIN.txt3')" clearable></el-input>
							</el-form-item>
						</div>
						<div v-if="!isCode" class="input_el">
							<div class="tit">{{ $t('LOGIN.txt4') }}</div>
							<el-form-item label="" prop="password">
								<el-input
									v-model="ruleForm.password"
									:placeholder="$t('LOGIN.txt5')"
									:type="showPwd ? 'text' : 'password'"
								>
									<div v-if="ruleForm.password" slot="suffix" style="height: 100%;display: flex;align-items: center;">
										<van-icon v-if="showPwd" size="16px" style="margin-right: 6px;cursor: pointer;" name="eye-o" @click="showPwd = !showPwd" />
										<van-icon v-else size="16px" style="margin-right: 6px;cursor: pointer;" name="closed-eye" @click="showPwd = !showPwd" />
										<van-icon size="14px" style="margin-right: 6px;cursor: pointer;" name="close" @click="ruleForm.password = ''" />
									</div>
								</el-input>
							</el-form-item>
						</div>
						<div v-if="isCode" class="input_el">
							<div class="tit">{{ $t('LOGIN.txt9') }}</div>
							<el-form-item label="" prop="code">
								<el-input v-model="ruleForm.code" :placeholder="$t('LOGIN.txt10')" clearable class="input_el_el" :style="lang == 'en' ? 'width: 43%;' : ''"></el-input>
								<el-button :disabled="isDisabled" class="btn_el" type="primary" size="mini" @click="getCode">
									{{ isDisabled ? count + ' ' +$t('LOGIN.txt14') : $t('LOGIN.txt13') }}
								</el-button>
							</el-form-item>
						</div>
						<!-- <div class="check_box">
							<span @click="checkLogType">{{ isCode ? $t('LOGIN.txt11') : $t('LOGIN.txt12') }}</span>
						</div> -->
					</el-form>
					<div class="btn_box">
						<van-button type="primary" block color="#4886FF" @click="submitForm('ruleForm')">{{ $t('LOGIN.txt6') }}</van-button>
					</div>
				</div>
			</div>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { login, loginCode, sendCode } from '@/api/public';
import md5 from 'js-md5';
export default {
	components:{
		//
	},
	data() {
		return {
			isLoading: true,
			showPwd: false,
			ruleForm: {
				account: '',
				password: '',
				code: ''
			},
			isCode: false,  //默认登录方式
			count: 60,  //验证码倒计时时长
			isDisabled: false,  //是否禁用发送按钮
			timer: null,  //定时器
			rules: {
				account: [
					{ required: true, message: this.$t('LOGIN.txt18'), trigger: 'blur' },
				],  // `${this.isCode}`
				password: [
					{ required: true, message: this.$t('LOGIN.txt5'), trigger: 'blur' },
				],
				code: [
					{ required: true, message: this.$t('LOGIN.txt10'), trigger: 'blur' },
				],
			},
			lang: localStorage.getItem('lang') || 'cn'
		}
	},
	created(){
		let that = this;
		document.addEventListener('keydown', that.keyDown);
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//切换登陆方式
		checkLogType() {
			let that = this;
			that.isCode = !that.isCode;
			if(that.isCode) {
				that.rules.account[0].message = that.$t('LOGIN.txt18');
			}else {
				that.rules.account[0].message = that.$t('LOGIN.txt3');
			}
		},
		//获取验证码
		getCode() {
			let that = this;
			if(that.ruleForm.account) {
				if(!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(that.ruleForm.account)) {
					that.$toast(that.$t('LOGIN.txt15'));
					return false;
				}
				that.$toast.loading({ duration: 0, forbidClick: true });
				//发送验证码
				sendCode({
					email: that.ruleForm.account,
					sign: md5(String(that.ruleForm.account)+'MasterControl')
				}).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$toast(that.$t('LOGIN.txt16'));
						//倒计时 makuluno1@163.com
						that.isDisabled = true;
						that.timer = setInterval(() => {
							that.count--;
							if(that.count <= 0) {
								clearInterval(that.timer);
								that.isDisabled = false;
								that.count = 60;
							}
						}, 1000);
					}
				});
			}else {
				that.$toast(that.$t('LOGIN.txt18'));
			}
		},
		//切换语种
		checkLang() {
			let that = this;
			if(that.$t('language.language') == 'EN') {
				localStorage.setItem('lang', 'en');
				setTimeout(() => {
					window.location.reload();
				}, 300);
			}else {
				localStorage.setItem('lang', 'cn');
				setTimeout(() => {
					window.location.reload();
				}, 300);
			}
		},
		keyDown() {
			let that = this;
			let key = window.event.keyCode;
			if(key == 13) {
				that.submitForm('ruleForm');
			}
		},
		//登录
		submitForm(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					that.$toast.loading({ duration: 0, forbidClick: true });
					if(that.isCode) {
						//验证码登录
						loginCode({
							email: that.ruleForm.account,
							code: that.ruleForm.code,
							leixing: 1
						}).then(res => {
							if(res.data.uinfo) {
								if(res.data.group_id) {
									localStorage.setItem('userConfig', res.data.group_id);
								}
								if(that.ruleForm.password == '123456') {
									localStorage.setItem('userOnce', 'yes');
								}else {
									localStorage.setItem('userOnce', 'no');
								}
								localStorage.setItem('userToken', res.data.uinfo.token);
								localStorage.setItem('userName', res.data.uinfo.username);
								localStorage.setItem('userAccount', res.data.uinfo.account);
								localStorage.setItem('userIs_file', res.data.uinfo.is_file);
								localStorage.setItem('userIs_folder', res.data.uinfo.is_folder);
								that.$router.replace('/index');
							}
						});
					}else {
						//密码登录
						login({
							user_id: that.ruleForm.account,
							password: that.ruleForm.password,
							// leixing: 1
						}).then(res => {
							if(res.data.id) {
								// if(res.data.group_id) {
								// 	localStorage.setItem('userConfig', res.data.group_id);
								// }
								// if(that.ruleForm.password == '123456') {
								// 	localStorage.setItem('userOnce', 'yes');
								// }else {
								// 	localStorage.setItem('userOnce', 'no');
								// }
								localStorage.setItem('userToken', res.data.token);
								localStorage.setItem('userName', res.data.username);
								localStorage.setItem('userAccount', res.data.user_id);
								localStorage.setItem('is_config', res.data.is_config);
								localStorage.setItem('is_file', res.data.is_file);
								localStorage.setItem('is_train', res.data.is_train);
								localStorage.setItem('is_capa', res.data.is_capa);
								localStorage.setItem('system', res.data.system);
								localStorage.setItem('users', res.data.users);
								localStorage.setItem('capa', res.data.capa);
								localStorage.setItem('documents', res.data.documents);
								localStorage.setItem('train', res.data.train);
								that.$router.replace('/task-list');
							}
						});
					}
				}else {
					return false;
				}
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	position: relative;
	.lang_box{
		position: absolute;
		top: 5vh;
		right: 5vw;
		font-size: 18px;
		cursor: pointer;
		color: #ffffff;
		user-select: none;
	}
	.msg_box{
		width: 900px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: #ffffff;
		display: flex;
		.right{
			width: 360px;
			padding: 50px 40px 0 40px;
			background-color: #F9F9F9;
			.check_box{
				text-align: right;
				span{
					color: #666666;
					cursor: pointer;
				}
			}
			.btn_box{
				padding-top: 40px;
			}
			.input_el{
				padding-top: 5px;
				.btn_el{
					padding: 7px 10px;
				}
				.input_el_el{
					width: 61%;
					margin-right: 10px;
				}
				.tit{
					padding-bottom: 5px;
					font-size: 12px;
					color: #A2A2A2;
				}
			}
			.top_box{
				padding-bottom: 10px;
				text-align: center;
				.tit{
					padding-top: 8px;
					font-size: 20px;
					font-weight: bold;
				}
				img{
					width: 80px;
				}
			}
		}
		.left{
			flex: 1;
			padding: 75px 83px;
			img{
				width: 375px;
			}
		}
	}
	.bg_box{
		width: 100vw;
		height: 100vh;
		img{
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
}
</style>
